// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { SamplesComponent } from "@app/samples/samples.component";

export const environment = {
  apiBaseUrl: 'https://api-platform.portaldev.mynexuscare.com',
  modules: [],
  production: false,
  routes: [
    {
      path: ':tenantId/notes',
      component: SamplesComponent,
      children: [
        { 
          path: 'notes-widget', 
          loadComponent: () => import('src/app/samples/note-widget-sample-page/note-widget-sample-page.component').then(i => i.NoteWidgetSamplePageComponent), 
          data: { 
            title: 'Notes Widget' 
          } 
        },
        { 
          path: 'notes-sidebar', 
          loadComponent: () => import('src/app/samples/note-sidebar-sample-page/note-sidebar-sample-page.component').then(i => i.NoteSidebarSamplePageComponent),
          data: { title: 'Notes Sidebar' } 
        },
        { 
          path: 'wound-tracker', 
          loadComponent: () => import('src/app/samples/wound-tracker-sample-page/wound-tracker-sample-page.component').then(i => i.WoundTrackerSamplePageComponent),  
          data: { title: 'Wound Tracker' } 
        },
        { 
          path: 'member-level-of-function-table', 
          loadComponent: () => import('src/app/samples/member-level-of-function-table-sample-page/member-level-of-function-table-sample-page.component').then(i => i.MemberLevelOfFunctionTableSamplePageComponent),
          data: { title: 'Member LOF' } 
        },
      ]
    },
  ],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
